<template>
    <i v-tooltip="tooltipText">
        <fa icon="paper-plane" style="color: #DD4D42;"/>
    </i>
</template>

<script>
import Tooltip from 'primevue/tooltip'

export default {
    name: 'rejectPaperIcon',
    props: ['tooltipText'],
    emits: [],
    directives: {
        'tooltip': Tooltip,
    },
}
</script>

<style scoped>
</style>

